import api from './api.js';

class Colleagues {
    constructor(){
        this.url_colleagues = 'Colleagues'
    }
    get(data){
        return api.get(`${this.url_colleagues}/${data.id}`);
    }
    all(showSpinner = true) {
        const params = {
            // Uncomment this if you want to not show the spinner while this completes.
            isDataSourceRequest: !showSpinner,
        }

        return api.get(`${this.url_colleagues}/`, params);
    }
    getDataSource(id){
        return api.getDataSource(`${this.url_colleagues}`, id);
    }  
    create(data){
        return api.put(`${this.url_colleagues}/`, data);
    }
    update(data){
        return api.put(`${this.url_colleagues}/${data.Id}`, data);
    }
}

export default new Colleagues;
